<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para Mostrar Dispositivos X Caseta   -->
        <v-dialog v-model="dialogGetDevicesByGuardhouse" scrollable max-width="500px">
            <v-form>
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('device_by_guardhouse')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="white"
                                icon
                                @click="getDeviceByGuardhouse">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogGetDevicesByGuardhouse = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="devicesByGuardhouse.length > 0">
                            <v-list three-line v-for="(item, i) in devicesByGuardhouse" :key="i">
                                <v-list-item>
                                  <v-list-item-avatar>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            medium
                                            color="gray"
                                            class="mr-2"
                                            @click="update = true, idUpdate = item.id, dialogDevice = true, fillFieldsDevice(item)"

                                        >
                                          mdi-pencil
                                        </v-icon>
                                      </template>
                                      <span>{{$t('change')}}</span>
                                    </v-tooltip>
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                      <v-list-item-title>{{$t('nombre')}}: {{item.name}}</v-list-item-title>
                                      <v-list-item-subtitle>UUID: {{item.uuid}}</v-list-item-subtitle>
                                      <v-list-item-subtitle>{{$t('label')}}: {{item.label}}</v-list-item-subtitle>
                                      <v-list-item-subtitle>{{$t('classification')}}: {{item.classification}}</v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-action class="text--">
                                    <v-list-item-action-text v-text="item.online === true ? 'Online' : 'Offline'"></v-list-item-action-text>
                                    <v-icon
                                        v-if="item.online === true"
                                        color="green"
                                    >
                                      mdi-wifi
                                    </v-icon>
                                    <v-icon
                                        v-else
                                        color="grey darken-3"
                                    >
                                      mdi-wifi-off
                                    </v-icon>
                                    <v-spacer/>
                                  </v-list-item-action>
<!--                                    <v-tooltip bottom>-->
<!--                                        <template v-slot:activator="{ on, attrs }">-->
<!--                                            <v-icon-->
<!--                                                    v-bind="attrs"-->
<!--                                                    v-on="on"-->
<!--                                                    medium-->
<!--                                                    color="red"-->
<!--                                                    class="mr-2"-->
<!--                                                    @click="idUpdate = item.id, deleteDevice()"-->

<!--                                            >-->
<!--                                                mdi-close-->
<!--                                            </v-icon>-->
<!--                                        </template>-->
<!--                                        <span>{{$t('delete')}}</span>-->
<!--                                    </v-tooltip>-->
                                </v-list-item>
                              <v-divider
                                  v-if="i < devicesByGuardhouse.length - 1"
                                  :key="i"
                              ></v-divider>
                            </v-list>
                        </div>
                        <div v-else>
                            {{$t('no_devices')}}
                        </div>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="dialogDevice" persistent scrollable max-width="400">
            <v-form
                    @submit.prevent="update
                            ? updateDevice(idUpdate)
                            : addDevice()"
            >
                <v-card class="elevation-5">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>
                            {{$t('add_device')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="clear(), dialogDevice = false"
                        ><v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field
                                :disabled="update"
                                v-model="uuid"
                                prepend-icon="mdi-numeric"
                                label="UUID"
                                :error-messages="errores.uuid"
                        ></v-text-field>
                        <v-text-field
                                v-model="name_device"
                                prepend-icon="mdi-developer-board"
                                :label="$t('nombre')"
                                :error-messages="errores.name"
                        ></v-text-field>
                        <v-text-field
                                v-model="label"
                                prepend-icon="mdi-tag"
                                :label="$t('label')"
                                :error-messages="errores.label"
                        ></v-text-field>
                        <v-text-field
                                v-model="classification"
                                prepend-icon="mdi-tag-multiple"
                                :label="$t('classification')"
                                :error-messages="errores.classification"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @click="clear(), dialogDevice = false">{{$t('cerrar')}}</v-btn>
                        <v-spacer/>
                        <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                        <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Caseta de Vigilacia     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_eliminar_caseta')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteGuardHouse()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('guardhouses')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="300">
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            v-on="on"
                            @click="update = false, cleanFields()"
                    >
                        + {{$t('anadir_caseta')}}
                    </v-btn>
                </template>
                <v-form
                        @submit.prevent="update
                            ? updateGuardHouse(idUpdate)
                            : addGuardHouse()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar color="primary">
                            <v-toolbar-title>
                                {{$t('guardhouses')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field
                                    v-if="dialog" autofocus
                                    v-model="name"
                                    name="name"
                                    prepend-icon="mdi-road"
                                    :label="$t('nombre')"
                                    :error-messages="errores.name"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('guardhouses')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :loading="loadingDataGuardHouses"
                    :items="guardHouses"
                    :search="search"
                    :footer-props="{
                        itemsPerPageOptions: [
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'), value: -1}
                        ],
                        itemsPerPageText: $t('filas_por_pagina')
                    }"
                    class="elevation-1"
                    :no-data-text="$t('no_records_yet')"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.id }}</td>
                        <td>{{ props.item.name }}</td>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fillFields(item), update = true, dialog = true, idUpdate = item.id"

                                >
                                    mdi-home-edit
                                </v-icon>
                            </template>
                            <span>{{$t('change')}}</span>
                        </v-tooltip>
<!--                        <v-tooltip bottom>-->
<!--                            <template v-slot:activator="{ on, attrs }">-->
<!--                                <v-icon-->
<!--                                        v-bind="attrs"-->
<!--                                        v-on="on"-->
<!--                                        medium-->
<!--                                        color="red"-->
<!--                                        class="mr-2"-->
<!--                                        @click="deleteDialog = true, idGuardHouseDelete = item.id"-->

<!--                                >-->
<!--                                    mdi-delete-->
<!--                                </v-icon>-->
<!--                            </template>-->
<!--                            <span>{{$t('delete')}}</span>-->
<!--                        </v-tooltip>-->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="primary"
                                        class="mr-2"
                                        @click="dialogDevice = true, update = false, cleanFieldsDevice(), idGuardHouseDelete = item.id"

                                >
                                    mdi-plus
                                </v-icon>
                            </template>
                            <span>{{$t('add_device')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="orange"
                                        class="mr-2"
                                        @click="dialogGetDevicesByGuardhouse = true, idGuardHouseDelete = item.id, getDeviceByGuardhouse()"

                                >
                                    mdi-developer-board
                                </v-icon>
                            </template>
                            <span>{{$t('show_devices')}}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import { mapState } from 'vuex'

export default {
  name: 'guard_houses',
  created () {
    this.getGuardHouses()
  },
  computed: {
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    name: '',
    header: [],
    loadingDataGuardHouses: false,
    loading: false,
    guardHouses: [],
    search: '',
    update: false,
    errores: [],
    idUpdate: 0,
    idGuardHouseDelete: 0,
    deleteDialog: false,
    headers: [],
    // Devices
    dialogDevice: false,
    uuid: '',
    name_device: '',
    label: '',
    classification: '',
    dialogGetDevicesByGuardhouse: false,
    devicesByGuardhouse: []
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('nombre'),
        align: 'center',
        sortable: true,
        value: 'name'
      }
    ]
  },
  methods: {
    getGuardHouses () {
      this.loadingDataGuardHouses = true

      HTTP.get('guardhouse/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(response => {
          this.guardHouses = response.data
          this.loadingDataGuardHouses = false
        })
        .catch(error => {
          this.loadingDataGuardHouses = false
          console.log(error)
        })
    },
    addGuardHouse () {
      this.errores = []
      this.loading = true
      HTTP.post('guardhouse/', {
          name: this.name
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_caseta_alta'))
          this.dialog = false
          this.getGuardHouses()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    updateGuardHouse (id) {
      this.errores = []
      this.loading = true
      HTTP.patch('guardhouse/' + id, {
        name: this.name
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.getGuardHouses()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_caseta_modificada'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    deleteGuardHouse () {

      HTTP.delete('guardhouse/' + this.idGuardHouseDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }).then(ok => {
        console.log(ok)
        console.log('Guard House con ID = ', this.idGuardHouseDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_caseta_eliminada'))
        this.getGuardHouses()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFields () {
      this.name = ''
    },
    fillFields (item) {
      this.name = item.name
    },
    getDeviceByGuardhouse () {
      this.devicesByGuardhouse = []
      HTTP.get('guardhouse/' + this.idGuardHouseDelete + '/devices/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(response => {
          this.devicesByGuardhouse = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    addDevice () {
      this.errores = []
      this.loading = true
      HTTP.post('guardhouse/devices/', {
          uuid: this.uuid,
          name: this.name_device,
          label: this.label,
          classification: this.classification,
          idGuardhouse: this.idGuardHouseDelete
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(ok => {
          console.log(ok)
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('device_added_successfully'))
          this.dialogDevice = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    updateDevice () {
      this.errores = []
      this.loading = true
      HTTP.patch('guardhouse/devices/' + this.idUpdate, {
          uuid: this.uuid,
          name: this.name_device,
          label: this.label,
          classification: this.classification
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(ok => {
          console.log(ok)
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('device_modified_successfully'))
          this.dialogDevice = false
          this.getDeviceByGuardhouse()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    deleteDevice () {
      this.errores = []
      this.loading = true
      HTTP.delete('guardhouse/devices/' + this.idUpdate, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(ok => {
          console.log(ok)
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('device_removed_successfully'))
          this.dialogDevice = false
          this.getDeviceByGuardhouse()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFieldsDevice () {
      this.uuid = ''
      this.name_device = ''
      this.label = ''
      this.classification = ''
    },
    fillFieldsDevice (item) {
      this.uuid = item.uuid
      this.name_device = item.name
      this.label = item.label
      this.classification = item.classification
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>

</style>
